export function snapshotObject(value: unknown): Record<string, unknown> {
  return value && typeof value === 'object' && !Array.isArray(value) ? (value as Record<string, unknown>) : {}
}

export function snapshotValue(value: unknown, field: string) {
  if (!value || typeof value !== 'object' || Array.isArray(value)) {
    return '—'
  }
  const data = (value as Record<string, unknown>)[field]
  return typeof data === 'string' || typeof data === 'number' ? String(data) : '—'
}
